import React, { useState, useEffect } from "react";
import Modal from "components/UI/Modal/Modal";
import { InsertModal, UpdateModal, DeleteModal } from "./Actions";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { routeInfo, userCredentials } from "recoilState/GlobalState";
import { HeaderButton } from "components";
import Add from "@mui/icons-material/Add";
import Cached from "@mui/icons-material/Cached";
import EditOutlined from "@mui/icons-material/EditOutlined";
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import { Buttons } from "components";
import { ACTIONS } from "consts/Actions";
import { ServicioTitles as titles } from "consts/titulos-de-tablas";
import styles from "styles/pages/Pages.module.scss";
import { useService } from "components/route/ServiceRoute";
import XGrid from "components/UI/Grid/XGrid";
import { RNHUnidadGet } from "services/services-mia/RNHUnidadGet";

export default function UnidadesSalud() {
    const credentials = useRecoilValue(userCredentials);
    const setRoute = useSetRecoilState(routeInfo);
    const [modalDetails, setModalDetails] = useState({ isOpen: false });
    const [loading, setLoading] = useState(false);
    const [unidades, setUnidades] = useState([]);
    const [rowSelected, setRowSelected] = useState({ status: false, row: {} });
    const { service } = useService();

    const getUnidades = async () => {
        setUnidades([]);
        setLoading(true);
        const result = await RNHUnidadGet(credentials);
        const newRows = result[0]?.rnhUnidadId ? result?.map((data) => {
            return {
                id: data.rnhUnidadId,
                cod: data.rnhUnidadCod,
                name: data.rnhUnidadNombre,
                desc: data.rnhUnidadDescripcion,
            };
        }) : []
        setUnidades(newRows);
        setLoading(false);
    }
    const closeModal = () => {
        setModalDetails({ isOpen: false });
    };
    const handleClick = ({ procede, title }) => {
        setModalDetails({ procede, title, isOpen: true });
    };

    useEffect(() => {
        getUnidades()
    }, [])
    useEffect(() => {
        setRoute({
            wordKey: `Unidades - Programa Salud RN`
        })
    }, [service.servicioNombre, setRoute])

    return (
        <main className={styles.main}>
            <Modal open={modalDetails.isOpen} title={modalDetails.title} onClose={closeModal}>
                {modalDetails.procede === ACTIONS.UPDATE && (
                    <UpdateModal
                        user={rowSelected.row}
                        updateList={getUnidades}
                        closeModal={closeModal}
                    />
                )}
                {modalDetails.procede === ACTIONS.EXPORT && (
                    <DeleteModal
                        user={rowSelected.row}
                        servicio={service}
                        updateList={getUnidades}
                        closeModal={closeModal}
                        setterRowSelected={setRowSelected}
                    />
                )}
                {modalDetails.procede === ACTIONS.INSERT && (
                    <InsertModal
                        servicio={service}
                        updateList={getUnidades}
                        closeModal={closeModal}
                    />
                )}
            </Modal>
            <div className={styles["filters-actions-right"]}>
                <Buttons>
                    <HeaderButton
                        text={"Actualizar"}
                        onClick={() => { getUnidades() }}
                        disabled={rowSelected.row.id || false}
                    >
                        <Cached />
                    </HeaderButton>
                    <HeaderButton
                        text={"Nueva unidad"}
                        handleClick={handleClick}
                        data={{
                            title: "Nueva unidad",
                            procede: ACTIONS.INSERT
                        }}
                        disabled={rowSelected.row.id || service.servicioPermiso !== 'E'}
                    >
                        <Add />
                    </HeaderButton>
                    <HeaderButton
                        text={"Modificar unidad"}
                        handleClick={handleClick}
                        data={{
                            title: "Modificar unidad",
                            procede: ACTIONS.UPDATE
                        }}
                        disabled={!rowSelected.row.id}
                    >
                        <EditOutlined />
                    </HeaderButton>
                    <HeaderButton
                        text={"Eliminar unidad"}
                        handleClick={handleClick}
                        data={{
                            title: "Eliminar unidad",
                            procede: ACTIONS.EXPORT
                        }}
                        disabled={!rowSelected.row.id}
                    >
                        <DeleteOutlineRoundedIcon />
                    </HeaderButton>
                </Buttons>
            </div>
            <div className={styles.container}>
                <XGrid
                    rows={unidades}
                    titles={titles}
                    loading={loading}
                    secondarySelected={rowSelected}
                    setSecondarySelected={setRowSelected}
                />
            </div>
        </main>
    );
}